module.exports = __webpack_public_path__ + "img/loading.8892c62.png";